(function() {
  'use strict';
  function init(root) {
    if (!root || root.dataset.kpmVideoHeroInit) return;
    root.dataset.kpmVideoHeroInit = '1';
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          root.setAttribute('data-revealed', '1');
          io.unobserve(root);
        }
      });
    }, { threshold: 0.15 });
    io.observe(root);
    var v = root.querySelector('video');
    if (v && v.hasAttribute('autoplay')) {
      v.muted = true;
      var play = v.play();
      if (play && typeof play.catch === 'function') play.catch(function(){});
    }
  }
  function boot() {
    document.querySelectorAll('[data-kpm-video-hero]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function(e) {
    e.target.querySelectorAll('[data-kpm-video-hero]').forEach(init);
  });
})();
